import { ROUTE_PATH_WIKI } from "page/wiki/wiki-config";

export const ROUTE_PATH_ONCE_BITTEN = `${ROUTE_PATH_WIKI}/once-bitten`;